import axios from '../axiosClient';
import { logError } from 'utils/logs';
export const getProjectInfo = async (id) => {
    var _a;
    try {
        const { data } = await axios.get(`/project/public/project/${id}`);
        return data;
    }
    catch (err) {
        logError(err);
        const error = err;
        if (error.isAxiosError && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404)
            return undefined;
        throw err;
    }
};
